"use client";
import { useEffect, useState } from "react";

export function useIsMobile(initialMobile: number = 769): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsMobile(window.innerWidth < initialMobile);
      }, 100); // Debounce resize by 100ms
    };

    if (typeof window !== "undefined") {
      // Sync state immediately on mount (client only, after hydration)
      setIsMobile(window.innerWidth < initialMobile);
      window.addEventListener("resize", handleResize);
    }

    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeoutId);
    };
  }, [initialMobile]);

  return isMobile;
}
